import { Injectable, inject } from '@angular/core';
import { SwUpdate } from '@angular/service-worker';

@Injectable({ providedIn: 'root' })
export class DynamicImportErrorRecoveryService {
  private swUpdate = inject(SwUpdate);

  private recoveryStarted = false;

  readonly DYNAMIC_IMPORT_ERROR_PATTERN =
    /Failed to fetch dynamically imported module|Importing a module script failed|error loading dynamically imported module/i;

  recoverFromError(error): boolean {
    if (!this.isDynamicImportError(error)) {
      return false;
    }

    if (this.recoveryStarted) {
      return true;
    }

    this.recoveryStarted = true;

    this.detectNewAppVersion();

    return true;
  }

  private isDynamicImportError(error): boolean {
    if (error && typeof error === 'object') {
      const { message } = error;

      if (typeof message === 'string') {
        return this.DYNAMIC_IMPORT_ERROR_PATTERN.test(message);
      }
    }

    return false;
  }

  private detectNewAppVersion(): void {
    if (!this.swUpdate.isEnabled) {
      // since sw checks for update upon initialization, leave it to be done there
      return;
    }

    this.swUpdate.checkForUpdate();
  }
}
